import * as React from "react";
import styled from "styled-components";
import { Rail } from "./Rail";
import { Thumb } from "./Thumb";
import { Track } from "./Track";
import { Value } from "./Value";

interface IProps {
  value: number;
  isDragging: boolean;
  onChange: (value: number) => void;
  setIsDragging?(value: boolean): void;
}

export const StyledSlider = ({
  value,
  onChange,
  isDragging,
  setIsDragging
}: IProps) => {
  return (
    <SliderView>
      <Value value={value} />
      <ControlsView>
        <Rail onUpdate={onChange} />
        <Track value={value} />
        <Thumb
          value={value}
          onUpdate={onChange}
          isDragging={isDragging}
          setIsDragging={setIsDragging}
        />
      </ControlsView>
    </SliderView>
  );
};

const SliderView = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ControlsView = styled.div`
  position: relative;
  top: 0.4em;
  display: flex;
  flex: 1 1 4.7em;
`;
